import React from "react";
import "./style.scss";
import MarketplaceButton from ".";
import Tooltip from "../../common/Tooltip";

import { useCountdown } from "../../../hooks/useCountdown";

const TimedMarketplaceButton = ({
  isInsufficientBalance,
  onClick,
  targetUpgradeDate,
  disabled = false,
  currentLevel,
  burnSmrtr
}) => {
  const { daysValue, days, hours, minutes, seconds, hoursValue, minutesValue, secondsValue} =
    useCountdown(targetUpgradeDate);

  const isTimeToUpgrade =
    !isInsufficientBalance &&
    (daysValue > 0 || hoursValue > 0 || minutesValue > 0 || secondsValue > 0);
  const isUpgrade = !isInsufficientBalance && !isTimeToUpgrade;

  return (
    <>
      {isInsufficientBalance && (
        <MarketplaceButton title={"Insufficient balance"} disabled isBlue />
      )}
      {isTimeToUpgrade && (
        <MarketplaceButton
          title={currentLevel >= 150 ? "Max level" : `Time to upgrade: ${days}:${hours}:${minutes}:${seconds}`}
          isBlue
          disabled
        />
      )}
      {isUpgrade && (
        <div className="dashboard__data__content--form__selectedToken--info__upgradeButton">
          <Tooltip tooltipText={`Upgrade Key Level by Burning ${burnSmrtr ? `$SMRTR or`: ''} $TRESR`}>
            <MarketplaceButton
              title={currentLevel >= 150 ? "Max level" : "Upgrade"}
              onClick={onClick}
              disabled={disabled || currentLevel >= 150}
              isBlue
            />
          </Tooltip>
        </div>
      )}
    </>
  );
};

export default TimedMarketplaceButton;
